<template>
  <v-layout row>

    <v-list-tile
      slot="activator"
      @click.native.stop="dialog = !dialog"
      disabled
    >
      <v-list-tile-avatar>
        <v-avatar size="32px" tile>
          <v-icon>add</v-icon>
        </v-avatar>
      </v-list-tile-avatar>
      <v-list-tile-title>Edytuj...</v-list-tile-title>
    </v-list-tile>
    <v-dialog v-model="dialog" max-width="500px">

      <!--<v-card>-->
        <!--<v-card-text>-->
          <!--<v-text-field-->
            <!--label="Nazwa napoju"-->
            <!--v-model="name"-->
            <!--required-->
          <!--&gt;</v-text-field>-->
          <!--&lt;!&ndash;<v-text-field label="File name"></v-text-field>&ndash;&gt;-->
          <!--&lt;!&ndash;<small class="grey&#45;&#45;text">* This doesn't actually save.</small>&ndash;&gt;-->
          <!--<v-text-field-->
            <!--label="Pojemność napoju"-->
            <!--v-model="size"-->
            <!--required-->
          <!--&gt;</v-text-field>-->
          <!--&lt;!&ndash;<small class="grey&#45;&#45;text">* This doesn't actually save.</small>&ndash;&gt;-->
        <!--</v-card-text>-->
        <!--<v-card-actions>-->
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn flat color="primary" @click="saveOwnDrink">Dodaj kubek</v-btn>-->
        <!--</v-card-actions>-->
      <!--</v-card>-->
    </v-dialog>

  </v-layout>

</template>

<script>
  export default {
    name: "editDrink",
    data() {
      return {
        dialog:false,
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/otherComponents/editDrink.vue